export const environment = {
  production: true,
  api_url: 'https://api.teste2.dimensaosistemas.com/api/',
  ibpt: {
    apiToken: 'izAHPfFOw0hajzbjjXkpXeEBqz6pjotveCjAXpja12sHLj5idnVE0Q8gLd95Bz-j',
    cnpj: '63926240000131',
  }
};
